import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        identifier: '',
        password: ''
    };
    public loading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) location.href = this.returnTo();
    }

    private returnTo(): string {
        const value = new URLSearchParams(location.search).get('returnTo') || '/graph';
        if (!value.startsWith('/') || value.startsWith('//')) return '/graph';
        return value;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        if (this.loading) return;

        let user = JSON.parse(JSON.stringify(this.data));
        user.identifier = String(user.identifier || '').trim();
        if (!user.identifier) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        try {
            let { code, data } = await wiz.call("login", user);

            if (code == 200) {
                location.href = this.returnTo();
                return;
            }
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        } finally {
            this.loading = false;
        }
    }
}

export default PageAccessComponent;